'use client';

import { Carousel } from '@c/index';
import { useQuery } from '@tanstack/react-query';
import { getLiveAuctions } from '@util/firestore/products';
import { renderProductCards } from 'features/homepage/utils';
import HomeSection from '../Home/components/HomeSection';
import SkeletonCarouselComponent from '@ui/SkeletonCarousel';

export default function LiveAuctions() {
  const { data: liveAuctions, isLoading } = useQuery({
    queryKey: ['liveAuctions'],
    queryFn: () => getLiveAuctions(),
  });
  if (!liveAuctions?.length && !isLoading) return null;
  return (
    <HomeSection
      title={isLoading ? '' : 'Live Auctions'}
      linkText={isLoading ? '' : 'See All'}
      href={isLoading ? '' : '/shop/auctions'}
      className="pl-8 sm:pl-0"
    >
      {isLoading ? (
        <SkeletonCarouselComponent />
      ) : (
        <Carousel
          spacing={0}
          basis="basis-[50%] sm:basis-auto"
          items={renderProductCards(liveAuctions, {
            data_source: 'firebase',
            page: 'home',
            section: 'live-auctions',
          })}
        />
      )}
    </HomeSection>
  );
}
